import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-validation-messages',
  templateUrl: './validation-messages.component.html',
  styleUrls: ['./validation-messages.component.scss']
})
export class ValidationMessagesComponent {
  @Input() form: FormGroup;

  get controls() {
    return Object.keys(this.form.controls).map(key => this.form.get(key));
  }

  shouldShowErrors(control: AbstractControl): boolean {
    return control && control.errors && (control.dirty || control.touched);
  }

  controlName(control: AbstractControl): string {
    const formGroup = control.parent.controls;
    return Object.keys(formGroup).find(name => control === formGroup[name])
      .replace(/_/g, ' ')
      .replace(/id/i, '')
      .replace(/^\w/, c => c.toUpperCase())
      .trim();
  }
}
